import * as m from "./../../dist/es2015/timeline.js";
export const am5timeline = m;